export const heading = [
  "S.No",
  "Prefix",
  "Start Number",
  "Suffix",
  "Preview",
  "Action",
];
export const addNewSetting = {
  prefix: "",
  nextinvoicenumber: "",
  suffix: "",
};
